<!-- Novo pedir delivery -->
<div *ngIf="isNewHomePedirDelivery" class="new-forgot-wrapper">

  <div class="new-forgot-header">
    <button class="new-forgot-back-button" (click)="backToLogin()">
      <img src="assets/icon/register-back.svg" alt="" />
    </button>
  </div>

  <div class="new-forgot-body">

    <div class="new-forgot-intro-container">
      <div class="new-forgot-intro-icon-wrapper">
        <span class="new-forgot-intro-icon"></span>
      </div>
      <h2 class="new-forgot-intro-title">Esqueceu a senha?</h2>
      <p class="new-forgot-intro-subtitle">Insira seu e-mail e clique no botão abaixo para receber um link para redefinir sua senha.</p>
    </div>

    <div class="new-forgot-form-container">

      <div class="new-forgot-field-container">
        <label class="new-forgot-field-label">Email</label>
        <div class="new-forgot-field-input-wrapper">
          <span class="new-forgot-field-icon new-forgot-field-icon--mail"></span>
          <input
            type="email"
            placeholder="seu@email.com"
            class="new-forgot-field-input"
            [(ngModel)]="email"
            (keyup.enter)="forgotPassword()"
            autocomplete="off"
            inputmode="email"
          />
        </div>
      </div>

      <button class="new-forgot-primary-button" (click)="forgotPassword()">
        Enviar link para email
      </button>

    </div>
  </div>

</div>

<!-- Antigo pedir delivery -->
<ng-container *ngIf="!isNewHomePedirDelivery">
<ion-header>
  <ion-toolbar color="danger">
    <div class="container-header">
      <ion-buttons>
        <ion-button routerDirection="back" mode="ios" (click)="backToLogin()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title class="text-toolbar" translate>Redefine password</ion-title>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="content-color">
  <section class="body-forgot">
    <div class="container">
      <div class="center-div-forgot">
        <div class="body-forgot-text">
          <h3 class="title-forgot" translate>Forgot password?</h3>
          <p translate>
            Enter your email and click the button below to receive a link to reset your password.
          </p>
        </div>
        <input autocomplete="off" placeholder="E-mail" type="text" class="input-email" name="email" [(ngModel)]="email">
      </div>
      <div class="entry-buttons">
        <ion-button color="danger" expand="block" class="button-login" strong="true" mode="ios" translate (click)="forgotPassword()">Send link to email</ion-button>
      </div>
    </div>
  </section>
</ion-content>
</ng-container>
